export const formatNumberWithSpaces = (number: number) => {
  if (number == null) return "";
  return number.toLocaleString("ru-RU");
};

export const formatUsdt = (number: number, noUSDT: boolean = false) => {
  if (number == null) return "";
  return `${formatNumberWithSpaces(number)} ${noUSDT ? "" : "USDT"}`;
};

export const formatRubles = (number: number) => {
  return `${formatNumberWithSpaces(number)} ₽`;
};

export const plural = (
  _value: number,
  one: string,
  two: string,
  many: string
) => {
  let value = _value;
  let floatPart = value - Math.floor(value);
  while (floatPart > 0) {
    value *= 10;
    floatPart = value - Math.floor(value);
  }
  return pluralInt(value, one, two, many);
};

const pluralInt = (
  value: number,
  one: string,
  two: string,
  many: string
): string =>
  value > 20
    ? plural(value % 10, one, two, many)
    : value === 0
      ? many
      : value === 1
        ? one
        : value < 5
          ? two
          : many;

export const getTronScanAddresUrl = (address: string) => {
  return `https://tronscan.org/#/address/${address}`;
};

export const getTronScanTxUrl = (hash: string) => {
  return `https://tronscan.org/#/transaction/${hash}`;
};
